import { ref } from 'vue'

const STORAGE_KEY = 'dss360:layout-full-width'

const isFullWidth = ref(localStorage.getItem(STORAGE_KEY) === 'true')

export function useLayoutWidth() {
  function toggle() {
    isFullWidth.value = !isFullWidth.value
    localStorage.setItem(STORAGE_KEY, String(isFullWidth.value))
  }

  return { isFullWidth, toggle }
}
